import React from 'react'
import { Switch, Route } from 'react-router-dom'
import MyParkingLot from '../views/MyParkingLot'
import Subscriptions from '../views/Subscriptions'
import Reservations from '../views/Reservations'
import { Authentication } from '../views/Authentication'
import PrivateRoute from '../elements/PrivateRoute'
import { ProfileProvider } from '../providers/ProfileProvider'
import { PermissionsContextProvider } from '../providers/PermissionProvider'
import { SubscriptionProvider } from 'components/providers/SubscriptionsProvider'
import { Alert } from 'components/elements/Alert'
import Preloader from 'components/elements/Preloader'

export const Main = () => {
  return (
    <SubscriptionProvider>
      <Alert />
      <Preloader />
      <Switch>
        <Route exact path="/">
          <Authentication />
        </Route>
        <Route path="/">
          <ProfileProvider>
            <PermissionsContextProvider>
              <PrivateRoute path="/my-parking-lot">
                <MyParkingLot />
              </PrivateRoute>
              <PrivateRoute path="/subscriptions">
                <Subscriptions />
              </PrivateRoute>
              <PrivateRoute path="/reservations">
                <Reservations />
              </PrivateRoute>
            </PermissionsContextProvider>
          </ProfileProvider>
        </Route>
      </Switch>
    </SubscriptionProvider>
  )
}
